import React from 'react';
import { Button } from './ui/button';
import { Badge } from './ui/badge';
import { MapPin, Calendar } from 'lucide-react';

const HeroSection = () => {
  const scrollToContact = () => {
    document.getElementById('contact')?.scrollIntoView({ behavior: 'smooth' });
  };

  return (
    <section className="relative min-h-screen flex items-center justify-center overflow-hidden">
      {/* Background with overlay */}
      <div 
        className="absolute inset-0 bg-cover bg-center bg-no-repeat"
        style={{
          backgroundImage: `linear-gradient(135deg, rgba(15, 23, 42, 0.8), rgba(15, 23, 42, 0.6)), url('https://customer-assets.emergentagent.com/job_perfect-match-17/artifacts/ohk6kkgs_Chambre%20Principale.jpg')`
        }}
      />
      
      {/* Content */}
      <div className="relative z-10 max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 text-center">
        <div className="max-w-4xl mx-auto">
          {/* Location Badge */}
          <a
            href="https://maps.app.goo.gl/8kZBFpFN3fg52wSE8"
            target="_blank"
            rel="noopener noreferrer"
            className="inline-block mb-6 hover:scale-105 transition-transform duration-300"
          >
            <Badge className="bg-white/20 text-white border-white/30 px-6 py-3 text-lg backdrop-blur-sm hover:bg-white/30 transition-all duration-300">
              <MapPin className="h-5 w-5 mr-2" />
              📍 Almadies, Dakar - Front de mer
            </Badge>
          </a>

          {/* Main Title */}
          <h1 className="text-5xl md:text-7xl font-bold text-white mb-6 leading-tight">
            Vivez l'Exclusivité
            <span className="block text-amber-300">aux Almadies</span>
          </h1>

          {/* Subtitle */}
          <h2 className="text-2xl md:text-3xl text-slate-100 mb-8 font-light">
            Appartements F5 – 250 m² – 250 M FCFA
          </h2>

          {/* Status Badge */}
          <div className="mb-10">
            <Badge className="bg-emerald-600 text-white text-lg px-6 py-3 font-semibold">
              <Calendar className="h-5 w-5 mr-2" />
              Gros œuvre en cours – Livraison 2026
            </Badge>
          </div>

          {/* Main CTA */}
          <Button 
            onClick={scrollToContact}
            size="lg"
            className="bg-amber-600 hover:bg-amber-700 text-white px-12 py-6 text-xl font-bold transform hover:scale-105 transition-all duration-300 shadow-2xl"
          >
            Réservez en VEFA dès maintenant
          </Button>

          {/* Quick Stats */}
          <div className="mt-16 grid grid-cols-1 md:grid-cols-3 gap-8 text-white">
            <div className="text-center">
              <div className="text-4xl font-bold text-amber-300">R+8</div>
              <div className="text-sm text-slate-200">Étages</div>
            </div>
            <div className="text-center">
              <div className="text-4xl font-bold text-amber-300">250m²</div>
              <div className="text-sm text-slate-200">Surface habitable</div>
            </div>
            <div className="text-center">
              <div className="text-4xl font-bold text-amber-300">F5</div>
              <div className="text-sm text-slate-200">4 Chambres + Salon</div>
            </div>
          </div>
        </div>
      </div>

      {/* Scroll indicator */}
      <div className="absolute bottom-8 left-1/2 transform -translate-x-1/2 text-white animate-bounce">
        <div className="w-6 h-10 border-2 border-white rounded-full flex justify-center">
          <div className="w-1 h-3 bg-white rounded-full mt-2 animate-pulse"></div>
        </div>
      </div>
    </section>
  );
};

export default HeroSection;